import {
  START_LOADING,
  STOP_LOADING,
  CHANGE_REF,
  CLEAR_REF,
} from "../types/index";
import { handleApiError } from "Helper";

export const changeLedgerLink = (component, ref) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const data = {
      type: component,
      ref: ref,
    };
    dispatch({ type: CHANGE_REF, payload: data });
    dispatch({ type: STOP_LOADING });
  } catch (error) {
    handleApiError(error);
  }
};

export const clearLedgerLink = (component, ref) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const data = {
      type: component,
      ref: ref,
    };
    dispatch({ type: CLEAR_REF, payload: data });
    dispatch({ type: STOP_LOADING });
  } catch (error) {
    handleApiError(error);
  }
};
